import styled, { css } from 'styled-components';
import Icon from 'components/Icon';
import { Dialog } from 'components/Dialog/dialog.component';

const Wrapper = styled.div`
  ${({ theme }) => theme.font.mainFont()};
  display: flex;
  overflow: auto;
  flex-direction: column;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.color.primaryGradient};
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('lg')} {
      background-repeat: no-repeat;
      background-position: right bottom;
    }
  `}
`;

const PaymentSectionLayout = styled.div`
  flex: 1 0 auto;
  margin-bottom: 70px;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('xl')} {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 80px;
      max-width: 1150px;
      margin: 40px auto 0;
      width: 100%;
    }

    ${mui.breakpoints.down('xs')} {
      margin-top: 0px;
      width: 100%;
    }
  `}
`;

const SplitBillWaitingTitleContainer = styled.div`
  display: flex;
  text-align: center;
  margin-top: 30px;
  flex-direction: column;
`;

const Title = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: ${({ theme: { color } }) => color.white_600};
`;

const SubTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: ${({ theme: { color } }) => color.white};
`;

interface TotalSpiltBillProps {
  bold?: boolean;
}

const TotalSpiltBill = styled.span<TotalSpiltBillProps>`
  font-weight: ${({ bold }) => (bold ? 500 : 'lighter')};
  font-size: 48px;
  line-height: 21px;
  margin-bottom: 30px;
`;

const TotalSpiltAmount = styled.span`
  font-weight: 500;
  font-size: 32px;
  line-height: 42px;
`;

const PaymentRemainTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`;

const QrIcon = styled(Icon)`
  && {
    path {
      fill: ${({ theme: { color } }) => color.white};
    }
  }
`;

const ShareQrCodeDialog = styled(Dialog)`
  && {
    ${({ theme: { mui } }) => css`
      ${mui.breakpoints.down('xs')} {
        bottom: 0px !important;
        top: auto !important;
      }
    `}

    .MuiDialog-container {
      ${({ theme: { mui } }) => css`
        ${mui.breakpoints.down('xs')} {
          height: auto;
          outline: 0;
        }
      `}
    }

    .MuiDialog-paper {
      ${({ theme: { mui } }) => css`
        min-width: 524px;

        ${mui.breakpoints.down('xs')} {
          margin: 0;
          width: 100%;
          min-width: 100%;
          height: 100%;
          min-height: 100%;
        }
      `}
    }
  }
`;

const ShareQrCodeContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  gap: 5px;
  color: white;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  text-transform: uppercase;

  &:hover {
    color: #2144bc;
    text-decoration: none;
    svg {
      path {
        fill: #2144bc;
      }
    }
  }
`;

export {
  Wrapper,
  PaymentSectionLayout,
  SplitBillWaitingTitleContainer,
  Title,
  SubTitle,
  TotalSpiltBill,
  TotalSpiltAmount,
  PaymentRemainTitle,
  QrIcon,
  ShareQrCodeContainer,
  ShareQrCodeDialog,
};
